import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import DualRoutingSection from "@/components/DualRoutingSection";
import LeadMagnets from "@/components/LeadMagnets";
import CountryHubs from "@/components/CountryHubs";
import CaseStudies from "@/components/CaseStudies";
import ConsultationSection from "@/components/ConsultationSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-slate-50">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <DualRoutingSection />
      <LeadMagnets />
      <CountryHubs />
      <CaseStudies />
      <ConsultationSection />
      <Footer />
    </div>
  );
}
